import React from 'react';
import { useLocation } from 'react-router-dom';

export const removeQueryParameters = url => {
  try {
    const urlObj = new URL(url);
    urlObj.search = '';
    return urlObj.href;
  } catch (e) {
    return url;
  }
};

export const stripHttp = url => url.replace(/(^\w+:|^)\/\//, '');

export const trimStringTo = (toLength, str) => {
  return str.length > toLength ? `${str.substring(0, toLength)}\u2026` : str;
};

export const useSearchParams = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
